import LoginForm from "../components/login/LoginForm.js";

function LoginPage(props) {
    return <>
        <LoginForm onLogin={props.onLogin} />
    </>
}

export default LoginPage;